import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from '../../utility/helper';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
}));

const LunchRoomAccordianCard = (props) => {
    const classess = useStyles();
    const { classes, item } = props;
    const CredentailInfo = item.actualData;

    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: 'none' }}>
                <CardContent className={classess.cardContent}>
                    <Box className={classes.rowContent}>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Full Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {CredentailInfo.contactName}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        {/* <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {CredentailInfo.contactEmail}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Phone
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {CredentailInfo.contactNo}
                                    </span>
                                </Typography>
                            </Box>
                        </Box> */}
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Relation
                                </Typography>
                                <Typography
                                    variant="h4"
                                    // flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {CredentailInfo.relationName}
                                    </span>
                                </Typography>
                            </Box>
                        </Box> 
                    </Box>
                    {[1, 2, 3, 4].map((item) => {
                        return (
                            <Box
                                key={`InfoSpa_${item}`}
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                    mb: 1,
                                }}></Box>
                        );
                    })}
                </CardContent>
            </Card>
        </>
    );
};

export default LunchRoomAccordianCard;
